/* @Author: liwen 
 * @Date: 2020-12-Su 05:06:06 
 * @Last Modified by:   liwen  */
import React from 'react';
import { DatePicker, Input, Checkbox, Button, Upload, Icon } from 'antd';
import SelectColumn from "../components/pmsWriting/selectColumn/selectColumn";

const options = [
    { label: '置顶', value: '1' },
    { label: '头条', value: '2' },
    { label: '推荐', value: '3' },
];
const uploadButton = (
    <div>
        <Icon type='plus' />
        <div className="ant-upload-text">点击上传</div>
    </div>
);
class BasicProperties extends React.Component{
    constructor(props){
        super(props);
        this.state = {
                
        }
    }

    render(){
        return(
            <>
                <div className="basic-properties">
                    <div className="box">
                        <div className="box-title">标题图</div>
                        <div className="item">
                            <Upload listType="picture-card">
                                {uploadButton}
                            </Upload>
                        </div>
                    </div>
                    <div className="box">
                        <div className="box-title">发布日期</div>
                        <div className="item">
                            <span>发布时间</span>
                            <DatePicker showToday={false} />
                        </div>
                        <div className="item">
                            <span>下线时间</span>
                            <DatePicker showToday={false} />
                        </div>
                    </div>
                    <div className="box">
                        <div className="box-title">显示位置/重要性</div>
                        <div className="item">
                            <span>重要性</span>
                            <Input />
                            <span>数值越小越重要</span>
                        </div>
                        <div className="item">
                            <Checkbox.Group options={options} />
                        </div>
                    </div>
                    <div className="box">
                        <div className="box-title">文章点击次数设置</div>
                        <div className="item">
                            <span>点击次数</span>
                            <Input />
                        </div>
                    </div>
                    <div className="box">
                        <div className="box-title">栏目设置</div>
                        <div className="item">
                            <span>所属栏目</span>
                            <Input />
                            <Button onClick={() => this.selectColumn.showSelectColumn()}>切换</Button>
                        </div>
                    </div>
                </div>
                <SelectColumn ref={(select) => this.selectColumn = select} />
            </>
        )
    }
}

export default BasicProperties